export const SESSION_USER_NAME = 'km_uid';
export const SESSION_HAS_SHOW_VERIFY = 'hasShowVerify';



// WEBPACK FOOTER //
// ./src/common/storage/StorageKey.js